module.exports = __webpack_public_path__ + "static/media/icon_ds_vungmien.695d4d34.svg";